<template>
  <div>
    <div class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <vs-tab :label="$t('reports.label.configurations')">
            <ConfigurationsSystem />
          </vs-tab>

          <vs-tab :label="$t('reports.label.provisioningConfiguration')">
            <provisioningConfiguration />
          </vs-tab>

          <vs-tab :label="$t('system.label.ManageCodes')">
            <manageCodes />
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import VxCard from "@/components/vx-card/VxCard.vue";

import manageCodes from "./manageCodes/manageCodesList.vue";
import provisioningConfiguration from "./provisioningConfiguration/provisioningConfigList.vue";
import ConfigurationsSystem from "./ConfigurationsSystem/configurationList.vue";
export default {
  data() {
    return {
      activeTab: 0,
    };
  },
  components: {
    VxCard,
    provisioningConfiguration,

    ConfigurationsSystem,
    manageCodes,
  },
};
</script>
